import { render, staticRenderFns } from "./Knowledge.vue?vue&type=template&id=1ab91ec8&lang=pug"
import script from "./Knowledge.vue?vue&type=script&lang=js"
export * from "./Knowledge.vue?vue&type=script&lang=js"
import style0 from "./Knowledge.vue?vue&type=style&index=0&id=1ab91ec8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports